module.exports = __webpack_public_path__ + "media/news/leipzig-news-02-59b9b71a.webp";